export default "__VITE_ASSET__68e0f007__"